/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

export const trees = {
  orgOnboardingForm: 'pnw-org-onboard',
  continueRegistrationForm: 'pnw-continue-registration',
  PasswordSet: 'partner-set-password',
  PasswordReset: 'pnw-reset-password',
  acceptTermsAndConditions: 'partner-accept-company-terms-and-conditions',
  userOnbaordingForm: 'pnw-user-onboarding',
  login: 'pnw-login',
  profileUpdate: 'pnw-profile-update',
  addCompany: 'pnw-add-company',
  changePassword: 'pnw-change-password',
  mfaReset: 'pnw-mfa-reset',
  inviteUser: 'admin-inviteUsers',
  samlLogin: 'pnw-saml-login'
};

// export const configOptions = {
//   clientId: process.env.NEXT_PUBLIC_FR_CLIENT_ID,
//   redirectUri: process.env.NEXT_PUBLIC_FR_REDIRECTURI,
//   scope: process.env.NEXT_PUBLIC_FR_OAUTH_SCOPES,
//   serverConfig: {
//     baseUrl: process.env.NEXT_PUBLIC_FR_SERVERCONFIG_BASEURL,
//     timeout: Number(process.env.NEXT_PUBLIC_FR_SERVERCONFIG_TIMEOUT)
//   },
//   support: process.env.NEXT_PUBLIC_FR_SUPPORT,
//   realmPath: process.env.NEXT_PUBLIC_FR_REALMPATH,
//   tree: process.env.NEXT_PUBLIC_TREE
// };\

const prod = process.env.NODE_ENV === 'production';
const app_environment = process.env.APP_ENV

console.log(process.env.APP_ENV);

let host = 'https://dev.ciam.prattwhitney.com';
let APP_INSIGHTS_INSTRUMENTATION_KEY ='2f493a79-da13-fe03-b99c-237e26d8a2ef';
let lifeRayURL = "https://stage-liferay.prattwhitney.com"
let walkMeURL = "'https://cdndd.walkme.com/users/b5ec695bce154052a9ad5cf1f4010aee/test/walkme_b5ec695bce154052a9ad5cf1f4010aee_https.js';"
 
switch (app_environment) {
  case 'production':
    host = 'https://portalidentity.prattwhitney.com'
    APP_INSIGHTS_INSTRUMENTATION_KEY ='9b6d20e2-187d-f7af-8919-f3b01c2fb148'
    lifeRayURL = "https://connect.prattwhitney.com/"
    walkMeURL = "'https://cdndd.walkme.com/users/b5ec695bce154052a9ad5cf1f4010aee/walkme_b5ec695bce154052a9ad5cf1f4010aee_https.js';"
    break;
  case 'qa':
    host = 'https://qa.ciam.prattwhitney.com'
    APP_INSIGHTS_INSTRUMENTATION_KEY ='d4183e2d-e971-f403-991b-782482b94470'
    lifeRayURL = "https://stage-liferay.prattwhitney.com"
    walkMeURL = "'https://cdndd.walkme.com/users/b5ec695bce154052a9ad5cf1f4010aee/test/walkme_b5ec695bce154052a9ad5cf1f4010aee_https.js';"
    break;
  case 'development':
    host = 'https://dev.ciam.prattwhitney.com'
    APP_INSIGHTS_INSTRUMENTATION_KEY ='2f493a79-da13-fe03-b99c-237e26d8a2ef'
    lifeRayURL = "https://stage-liferay.prattwhitney.com"
    walkMeURL = "'https://cdndd.walkme.com/users/b5ec695bce154052a9ad5cf1f4010aee/test/walkme_b5ec695bce154052a9ad5cf1f4010aee_https.js';"
    break;
  default:
    break;
}

export const configOptions = {
  clientId: 'dashboardAppClient',
  redirectUri: host + '/identity/pageNotFound',
  instrumentationKey:APP_INSIGHTS_INSTRUMENTATION_KEY,
  lifeRayURL: lifeRayURL,
  walkMeURL: walkMeURL,
  scope: 'openid profile email fr:idm:*',
  serverConfig: {
    baseUrl: host + '/login/',
    timeout: 60000
  },
  support: 'legacy',
  realmPath: 'PnW',
  tree: 'pnw-login'
};
export const idmConfigOptions = {
  baseUrl: host + '/openidm/'
};